import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Helpers } from 'shared-components/helpers/helpers';
import { Avatar } from 'shared-components/image/avatar';
import SharedIntlProviderHOC from '../../../shared-components/hocs/sharedIntlProviderHOC';
import { BookingSummaryItem } from '../../common/items/BookingSummaryItem';
import { checkIsGuestView } from '../../common/utils/check-is-guest-view';
import SvgPowerHost from '../../../shared-components/icons/PowerHost';

const getPowerHostImgUrl = () => {
  switch (SharedIntlProviderHOC.getLocale()) {
    case 'fr-FR':
      return 'https://assets.peerspace.com/powerhost_fr.svg?v=rb';
    case 'de-DE':
      return 'https://assets.peerspace.com/powerhost_de.svg?v=rb';
    case 'es-ES':
      return 'https://assets.peerspace.com/powerhost_es.svg?v=rb';
    default:
      return 'https://assets.peerspace.com/powerhost_eng.svg?v=rb';
  }
};

export const BookingSummaryUser = ({ booking, profile, iosWebViewConfig }) => {
  const isGuestView = checkIsGuestView(profile, booking);
  const displayedUser = isGuestView ? booking.host : booking.guest;

  const avatarUrl = `https://img.peerspace.com/image/upload/c_crop,g_custom/f_auto,fl_progressive/c_scale,dpr_2.0,h_100,w_100/${displayedUser?.avatar_id}`;

  const wrapContent = (content) =>
    iosWebViewConfig?.isWebView ? (
      <span className='inline-block'>{content}</span>
    ) : (
      <a
        className='inline-block'
        target='_blank'
        href={`/profiles/${displayedUser?.sso_id || displayedUser?.ssoid}`}
      >
        {content}
      </a>
    );

  return (
    <div className='booking-summary-user'>
      <BookingSummaryItem
        testingId='booking-summary-user'
        label={
          isGuestView ? (
            <FormattedMessage
              id='inbox.summary_props.user_host'
              defaultMessage='Host'
            />
          ) : (
            <FormattedMessage
              id='inbox.summary_props.user_guest'
              defaultMessage='Guest'
            />
          )
        }
      >
        {wrapContent(
          <div className='flex middle'>
            <span
              className='inline-block margin-lg-right'
            >
              <Avatar src={avatarUrl} maxWidth={60} />
            </span>
            <span>
              <span className='text-large' data-testing-id='host-name'>
                {displayedUser?.name?.first} {displayedUser?.name?.last}
              </span>
              {Helpers.isPowerHost(displayedUser) && (
                <div className="power-host-badge">
                  <SvgPowerHost width={12} height={16} />
                  <FormattedMessage
                    id="inbox.booking_summary_user.power_host"
                    defaultMessage="Power Host"
                  />
                </div>
              )}
              {!isGuestView && (
                <>
                  {!!displayedUser?.organization && (
                    <div className='text-gray-dark'>
                      {displayedUser.organization}
                    </div>
                  )}
                  {!!displayedUser?.profession && (
                    <div className='text-gray-dark'>
                      {displayedUser.profession}
                    </div>
                  )}
                </>
              )}
            </span>
          </div>
        )}
      </BookingSummaryItem>
    </div>
  );
};

BookingSummaryUser.propTypes = {
  booking: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  iosWebViewConfig: PropTypes.shape({
    isWebView: PropTypes.bool
  })
};
